
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { tokenStorage } from '../utils/tokenStorage';

const PrivateRoute = ({ children }) => {
  const { userId } = useAuth();

  // ← also check tokenStorage in case AuthContext hasn't updated yet
  const isAuthenticated = userId || tokenStorage.isLoggedIn();

  return isAuthenticated ? children : <Navigate to="/login" replace />;

};

export default PrivateRoute;